import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder, accessNested } from 'utils/utils';

import Store from 'store/store';

import Facebook from 'components/bolt/icons/facebook';
import Twitter from 'components/bolt/icons/twitter';
import Twitch from 'components/bolt/icons/twitch';
import Instagram from 'components/bolt/icons/instagram';
import Youtube from 'components/bolt/icons/youtube';
import Snapchat from 'components/bolt/icons/snapchat';
import Tiktok from 'components/bolt/icons/tiktok';
import Spotify from 'components/bolt/icons/spotify';
import Pinterest from 'components/bolt/icons/pinterest';
import Giphy from 'components/bolt/icons/giphy';
import Tumblr from 'components/bolt/icons/tumblr';
import Vimeo from 'components/bolt/icons/vimeo';
import Mail from 'components/bolt/icons/mail';
import Threads from 'components/bolt/icons/threads';

import Link from 'components/bolt/link/link';

import s from 'components/bolt/socials/socials.sss';

export default class Socials extends Component {
	render(props) {
		const { socials = {}, navOpen } = props;
		// allow for injecting custom styles
		const iconStyle = props.iconStyle ? props.iconStyle : s.icon;

		// TODO: dynamic import
		const icons = {
			facebook: <Facebook class={iconStyle} />,
			twitter: <Twitter class={iconStyle} />,
			twitch: <Twitch class={iconStyle} />,
			instagram: <Instagram class={iconStyle} />,
			youtube: <Youtube class={iconStyle} />,
			snapchat: <Snapchat class={iconStyle} />,
			tiktok: <Tiktok class={iconStyle} />,
			spotify: <Spotify class={iconStyle} />,
			pinterest: <Pinterest class={iconStyle} />,
			giphy: <Giphy class={iconStyle} />,
			tumblr: <Tumblr class={iconStyle} />,
			vimeo: <Vimeo class={iconStyle} />,
			email: <Mail class={iconStyle} />,
			threads: <Threads class={iconStyle} />,
		};

		const entries = Object.entries(socials);
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});
		const isRTL = accessNested(Store.get(), 'appData.styling.fontVariables.textDirection') === 'rtl';
		return (
			<div class={joinClasses(s.socials, props.class, navOpen && s.navOpen)}>
				{sortObjectByOrder(socials).slice(0, 5).map(social => {
					const id = entries.find(el => el[1].destination === social.destination)[0];
					let icon = icons[id];
					if (!icon && social.iconURL) {
						const iconSrc = (navOpen && social.iconNav) ? social.iconNav : social.iconURL;
						icon = <img class={s.icon} src={iconSrc} alt='' />;
					}
					return (
						<Link
							class={joinClasses(!props.iconStyle && s.social, s[id], isRTL && s.rtlSocial)}
							href={social.destination}
							target="_blank"
							rel="noopener noreferrer"
							key={id}
							onClick={()=> {Store.emit('CLICKED_FOLLOW', id);}}
							ariaLabel={accessibilityCopy.$SOCIAL_ARIA.replace('<platform>', id)}
						>
							{icon}
						</Link>
					);
				})}
			</div>
		);
	}
}
